export default __webpack_public_path__ + "static/media/scan-placeholder.22d7a718.png";